import type { ComponentType } from 'react';
import type { PageKey } from '../head';
import { ClientPage } from './ClientPage';
import { HubspotAppPage, SecurityPage, SupportPage } from './DocPage';
import { FitCheckPage } from './FitCheckPage';
import { RepsLandingPage } from './RepsLandingPage';

export const PAGE_COMPONENTS: Record<PageKey, ComponentType> = {
  client: ClientPage,
  reps: RepsLandingPage,
  fitCheck: FitCheckPage,
  hubspotApp: HubspotAppPage,
  support: SupportPage,
  security: SecurityPage,
};

export { ClientPage, FitCheckPage, HubspotAppPage, RepsLandingPage, SecurityPage, SupportPage };
